<template>
  <nav id="navbar-main" class="navbar">
    <div class="navbar-brand">
      <a class="navbar-item" @click.prevent="menuToggle">
        <img src="@/assets/img/logo.png" alt="apilogik" />
      </a>
      <div class="navbar-item">
        <b>{{ navTitle }}</b>
      </div>
    </div>
    <div class="navbar-brand is-right">
      <a
        class="navbar-item navbar-item-menu-toggle is-hidden-desktop"
        @click.prevent="menuNavBarToggle"
      >
        <b-icon :icon="menuNavBarToggleIcon" custom-size="default" />
      </a>
    </div>
    <div
      class="navbar-menu fadeIn animated faster"
      :class="{ 'is-active': isMenuNavBarActive }"
    >
      <div class="navbar-end">
        <!-- Hide for now -->
        <!-- <a hidden class="navbar-item has-divider is-desktop-icon-only" title="About">
          <b-icon icon="help-circle-outline" custom-size="default"/>
          <span>About</span>
        </a> -->
        <a
          class="navbar-item has-divider is-desktop-icon-only"
          title="Sound"
          @click.prevent="toogleMute"
        >
          <b-icon
            :icon="isMute ? 'bell-off-outline' : 'bell-outline'"
            custom-size="default"
          />
          <span>Sound</span>
        </a>
        <a
          class="navbar-item has-divider is-desktop-icon-only"
          title="Fullscreen"
          @click.prevent="toogleFullscreen"
        >
          <b-icon
            :icon="isFullscreen ? 'fullscreen-exit' : 'fullscreen'"
            custom-size="default"
          />
          <span>Fullscreen</span>
        </a>
        <nav-bar-menu class="has-divider has-user-avatar" has-dropdown>
          <user-avatar :avatar="auth.user.avatar" />
          <div class="is-user-name">
            <span>{{ auth.user.username }}</span>
          </div>

          <div slot="dropdown" class="navbar-dropdown">
            <router-link class="navbar-item" to="/profile">
              <b-icon icon="account" custom-size="default"></b-icon>
              <span>Profile</span>
            </router-link>
            <hr class="navbar-divider" />
            <a class="navbar-item" @click="logout">
              <b-icon icon="logout" custom-size="default"></b-icon>
              <span>Log Out</span>
            </a>
          </div>
        </nav-bar-menu>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import NavBarMenu from '@/components/layout/NavBarMenu'
import UserAvatar from '@/components/base/UserAvatar'

export default {
  name: 'NavBar',
  components: {
    UserAvatar,
    NavBarMenu
  },
  data() {
    const isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false
    return {
      isMenuNavBarActive: false,
      isFullscreen
    }
  },
  computed: {
    isMute() {
      return this.$store.state.setting.isMute
    },
    menuNavBarToggleIcon() {
      return (this.isMenuNavBarActive) ? 'close' : 'dots-vertical'
    },
    menuToggleIcon() {
      return this.isAsideExpanded ? 'backburger' : 'forwardburger'
    },
    ...mapState({ auth: 'auth' }),
    navTitle() {
      return 'Manager Dashboard'
    }
  },
  methods: {
    menuToggle() {
      // this.$router.replace({ name: this.auth.preferences.landing_page || 'dashboard' })
      this.$router.replace({ name: 'dashboard' })
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = (!this.isMenuNavBarActive)
    },
    logout() {
      this.$store.dispatch('auth/logout', this.form)
        .then(() => { this.$router.replace({ name: 'login' }) })
    },
    backToSuperAdmin() {
      this.$store.dispatch('auth/superLogout', { username: this.auth.superUser.username })
        .then(() => { this.$router.go() })
    },
    toogleFullscreen(event) {
      let element = document.documentElement

      if (event instanceof HTMLElement) {
        element = event
      }

      const isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false
      this.isFullscreen = !isFullscreen

      element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false }
      document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false }

      isFullscreen ? document.cancelFullScreen() : element.requestFullScreen()
    },
    toogleMute() {
      this.$store.commit('setting/toogleMute')
    },
    hasPermission(permission, method) {
      return this.$store.getters['auth/hasPermission'](permission, method)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-dropdown {
  right: 0;
}
</style>
